<template>
    <div class="card buildingCard" v-if="buildingProcessedId">
        <div class="card-body buildingCard-body">
            <div class="card-title buildingCard-title" v-if="pageTitle">
                    <span class="iconBeforeTitle">
                        <i class="fas fa-images"></i>
                     </span>
                {{pageTitle}}
                <ToolTip>
                    <sup class="superScript">
                        <i class="fas fa-info-circle"
                           data-toggle="tooltip"
                           data-placement="top"
                           data-html="true"
                           title=""
                           data-original-title='Floor Plans'
                        ></i>
                    </sup>
                </ToolTip>
            </div>
            <iframe class="floorPlanIframe"
                    v-bind:src="`${fixtureFrontendUrl}/?siteId=${encodeURIComponent(buildingProcessedId)}&fixtureBaseUrl=${encodeURIComponent(fixtureUrl)}&emiotBaseUrl=${encodeURIComponent(emiotUrl)}`"></iframe>
        </div>
    </div>
</template>
<script>
import ToolTip from '@/components/tool-tip/ToolTip.vue'

export default {
    props: {
      buildingId: Number | String,
      pageTitle: String,
    },

    mounted () {
      this.destroyed = false;
    },
    data () {
      return {
        destroyed: false,
      }
    },
    components: {
      ToolTip,
    },
    created () {
      window.addEventListener('message', this.receiveMessage);
    },
    beforeDestroy () {
      this.destroyed = true;
      window.removeEventListener('message', this.receiveMessage);
    },
    methods: {
      async receiveMessage(event) {
        if (event.origin === this.fixtureFrontendUrl || event.origin === window.origin) {
          let data = JSON.parse(event.data);
          switch(data.method) {
            case 'get_new_access_token':
              const token = await this.$store.getters.firebaseUser.getIdToken();
              event.source.postMessage(JSON.stringify({uuid: data.uuid, data: token}), event.origin);
              break;
          }
        }
      },
    },

    computed: {
      buildingProcessedId: function () {
        return this.buildingId
      },
      fixtureUrl: function() {
        return this.$store.getters.getSection('fixture').base_url.replace(/\/$/, '');
      },
      emiotUrl: function() {
        // Unlike the sections for fixture and auth, the emiot section's base_url is actually the relative path to
        // the current domain. So we need to grab the current domain and append this path to it.
        const path = this.$store.getters.getSection('emiot').base_url.replace(/\/$/, '');
        return window.location.protocol + '//' + window.location.host + path;
      },
      fixtureFrontendUrl: function() {
        return 'https://fixture-frontend.wbstech.com.au';
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
    .floorPlanIframe {
        width: 100%;
        height: 80vh;
        border-style: none;
    }
</style>